import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-focus-flow");
import { style } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { textStyles } from '@paypalcorp/pp-react-text';
import { elevationStyles } from '@paypalcorp/pp-react-elevation';
import { ZINDEX_MODAL } from '@paypalcorp/pp-react-utils';
const COMPONENT_NAME = 'focus_flow';
const getDebugId = (suffix, prefix = COMPONENT_NAME) => `${prefix}_${suffix}`;
const headerWidth = '44rem';
const contentWidth = '36rem';
const headerFlexBasis = `calc(2 * ${tokens.space['300']})`;
const base = style({
  position: 'fixed',
  inset: '0',
  backgroundColor: tokens.color.background.surface,
  zIndex: ZINDEX_MODAL
}, getDebugId('base'));
const wrapper = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
  width: '100%'
}, getDebugId('wrapper'));
const container = style({
  height: '100%',
  margin: '0 auto'
}, getDebugId('container'));
const content = style([textStyles.body, {
  overflow: 'auto',
  height: '90vh',
  position: 'relative',
  borderRadius: 'inherit',
  padding: `${tokens.space['200']} 0`,
  margin: '0 auto',
  width: contentWidth,
  '@media': {
    [`screen and (max-width: ${headerWidth})`]: {
      width: '100%',
      padding: tokens.space['200'],
      height: '84vh'
    }
  }
}], getDebugId('content'));
const header = style({
  width: '100%'
}, getDebugId('header'));
const headerContent = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: tokens.space['200'],
  position: 'relative',
  flex: '0 0 auto',
  zIndex: '1',
  width: headerWidth,
  margin: '0 auto',
  padding: `${tokens.space['150']} 0`,
  '@media': {
    [`screen and (max-width: ${headerWidth})`]: {
      width: '100%',
      padding: `${tokens.space['100']} ${tokens.space['200']}`
    }
  }
}, getDebugId('header_content'));
const headerAction = style({
  flex: `0 0 ${tokens.size.icon.lg}`
}, getDebugId('header_action'));
const headerTitle = style([textStyles.body, {
  flex: `1 1 ${headerFlexBasis}`,
  margin: `${tokens.space['100']} 0`,
  textAlign: 'center'
}], getDebugId('header_title'));
const headerClose = style({
  flex: `0 0 ${tokens.size.icon.lg}`
}, getDebugId('header_close'));
const headerLogo = style({
  display: 'flex',
  flex: `1 1 ${headerFlexBasis}`,
  justifyContent: 'center',
  marginTop: `${tokens.space['100']}`,
  width: `${tokens.size.icon.md}`,
  height: `${tokens.size.icon.md}`
}, getDebugId('header_logo'));
const headerScrolled = style([elevationStyles.level3], getDebugId('header_scrolled'));
export { base, content, container, header, headerContent, headerAction, headerClose, headerLogo, headerTitle, headerScrolled, wrapper };
__vanilla_filescope__.endFileScope();
